const firebaseConfig = {
  apiKey: "AIzaSyAbKH9PAOiTHlXp7qAFizTY2pXBdkmTzag",
  authDomain: "powerx-ar.firebaseapp.com",
  projectId: "powerx-ar",
  storageBucket: "powerx-ar.appspot.com",
  messagingSenderId: "622919357889",
  appId: "1:622919357889:web:c2ac91aa581425eaa38b40"
};


export default firebaseConfig;